// LogoFormUI.tsx
import { Box, Paper, Typography, Button } from "@mui/material";
import React from "react";

import { ImageDropzone } from "0.Mine/0.Components/Reusable/ImageDropzone";
import ArgonDropzone from "components/ArgonDropzone";

interface LogoFormUIProps {
  logo: File | null;
  banner: File | null;
  logoString: string | null;
  bannerString: string | null;
  handleLogoChange: (files: File) => void;
  handleBannerChange: (files: File) => void;
  handleLogoDelete: () => void;
  handleBannerDelete: () => void;
}

const LogoFormUI: React.FC<LogoFormUIProps> = ({
  logo,
  banner,
  handleLogoChange,
  logoString,
  bannerString,
  handleBannerChange,
  handleLogoDelete,
  handleBannerDelete,
}) => {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Logo
      </Typography>
      <ImageDropzone onDropFile={handleLogoChange} initialImage={logoString} />
      <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
        Webfiles supported: PNG, JPG, SVG. Max dimensions: 5MB
      </Typography>

      <Typography variant="h5" sx={{ mb: 3 }}>
        Banner
      </Typography>
      <ImageDropzone onDropFile={handleBannerChange} initialImage={bannerString} />
    </Box>
  );
};

export default React.memo(LogoFormUI);
